var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalAndRegionalNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 5.15c-1.68-.31-9.3-1.08-9.61.47-.58 2.8-.8 3.4-.8 3.76 0 .87 1.94 1 2.81 1.14s1.94.29 2.92.4a11.4 11.4 0 0 0 3.85-.28c.29 0 .68 0 .9-.34a2.66 2.66 0 0 0 .15-1.3c.34-2.77.4-3 .3-3.34a.67.67 0 0 0-.52-.51Zm-1 4.36-1.7.28a30.3 30.3 0 0 1-4.81-.23 6.67 6.67 0 0 1-2-.28c0-.19-.09.74.29-2.08 0 0 .36-1.37.36-1.45.15.37 5-.24 7.2.14q.55.09 1.08.21l0 .46c-.52 3.63-.44 2.72-.45 2.95Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.54 7a.34.34 0 0 0 .46-.17c.58-.9-1.81-1.11-3.24-.87a.35.35 0 0 0-.37.32c-.04.72 2.45.41 3.15.72Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.44 9.13a5 5 0 0 0 3.08.48c.43.14 1.06-.56.19-.86a3.36 3.36 0 0 0-.6-.09c-.96-.15-3.11-.4-2.67.47Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78 12.72c-4.92-.13-4.67-.09-4.8.13a.28.28 0 0 0 .15.42c.16.09.06.05 4.61.52a73.45 73.45 0 0 0 9.5 0 .34.34 0 0 0 0-.68c-2.38 0-3-.23-9.46-.39Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.68 16.61c-5.44-.27-3.68-.55-8.64-.47-.89 0-1.78.05-2.67 0-.35 0-2.17-.26-2.3-.23a.32.32 0 0 0 0 .61c.1 0-.16 0 2.25.44a77.28 77.28 0 0 0 7.73.39l1.13 0c4.08.01 3.37-.77 2.5-.74Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10.27c-.13-3.52-.05-2.5-.14-4.86a.44.44 0 0 0-.76-.28 2.72 2.72 0 0 1-2.33 1.25 21.46 21.46 0 0 0 .56-2.94.88.88 0 0 0-.22-.6c-.31-.3-3-.21-3.48-.2-3.05.09-5.71-.27-9.06-.2-4.62.1-5.83-.73-5.47.2a.45.45 0 0 0 .3.24 33.56 33.56 0 0 0 5.17.37c4.41.09 4.28.53 11.32.53l.17 0c0 1.27-1 3.8-1 8.45 0 1.64.13 6.24.85 7.56a2.26 2.26 0 0 0 .4.51c-3.31 1.08-15.91.5-17.78-.21-.32-.12-.77-.16-.9-.36-1.17-1.73.06-9.79.28-11.81a27.82 27.82 0 0 1 .67-3.53A7.91 7.91 0 0 0 3 2.69a.31.31 0 0 0-.58 0c.09-.1-.89 2.79-1.25 5.18C.72 10.49-.86 18.1.61 20.33c.4.61 1 .63 1.45.81a11.09 11.09 0 0 0 3.14.51c2.08.13 15.3.61 16.69-1.21 2.16-2.82 2.2-6.66 2.11-10.17ZM21.3 20a1 1 0 0 1-.8-.58c-.61-1.2-.59-5.82-.53-7.19A33.39 33.39 0 0 1 20.61 7a3.11 3.11 0 0 0 1.24-.07 3.52 3.52 0 0 0 1.09-.52C22.61 13 23.52 16.56 21.3 20Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.43 8.91c-.57-.41-.55 1-.68 2.15a19.8 19.8 0 0 0 .06 4.15.34.34 0 0 0 .68 0 20.13 20.13 0 0 0 .31-4.15c-.28-2.29-.19-2.06-.37-2.15Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalAndRegionalNews);
export default __webpack_public_path__ + "static/media/local-and-regional-news.ceabca65358570516f4b289accaab715.svg";
export { ForwardRef as ReactComponent };